import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ListComponent, Order, OrderRepositoryService } from 'reg-hub-common';

@Component({
    selector: 'app-bundle-orders-list',
    templateUrl: './bundle-orders-list.component.html',
    styleUrl: './bundle-orders-list.component.css',
    animations: [
        trigger('detailExpand', [
            state('collapsed,void', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BundleOrdersListComponent extends ListComponent<Order> {
  protected _expandedOrder: Order | null = null;

  displayedColumns: string[] = [
    'referenceNumber',
    'orderTypeID',
    'orderStatusTypeID',
    'country',
    'jurisdiction',
    'dateRequested'
  ];

  columnsToDisplayWithView = [...this.displayedColumns, 'view', 'indicator'];

  constructor(
    repo: OrderRepositoryService,
    private router: Router) {
    super(repo);
  }

  protected viewOrder(order: Order, newTab: boolean) {
    if (newTab) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['orders', order.id])
      );

      window.open(url, '_blank');
    }
    else {
      this.router.navigate(['orders', order.id])
    }
  }
}
